import script from "./CharacteristicDepartment.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacteristicDepartment.vue?vue&type=script&setup=true&lang=js"

import "./CharacteristicDepartment.vue?vue&type=style&index=0&id=a7f23794&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7f23794"]])

export default __exports__